import { render } from "./DownloadPatientData.vue?vue&type=template&id=6c6801d4&ts=true"
import script from "./DownloadPatientData.vue?vue&type=script&lang=ts"
export * from "./DownloadPatientData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/PatientDetail/DownloadPatientData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c6801d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c6801d4', __exports__)) {
    api.reload('6c6801d4', __exports__)
  }
  
  module.hot.accept("./DownloadPatientData.vue?vue&type=template&id=6c6801d4&ts=true", () => {
    api.rerender('6c6801d4', render)
  })

}


export default __exports__